
export const getGoogleDriveDirectLink = (url: string | null | undefined): string | undefined => {
    if (!url) return undefined;

    // Si ya es un enlace directo o no es de Google Drive, lo devolvemos tal cual
    if (!url.includes('drive.google.com') && !url.includes('docs.google.com')) {
        return url;
    }

    // Intento 1: Extraer ID de /file/d/......./view
    const matchId = url.match(/\/d\/([a-zA-Z0-9_-]+)/);
    if (matchId && matchId[1]) {
        // Opción A: uc?export=view&id=...
        // return `https://drive.google.com/uc?export=view&id=${matchId[1]}`;
        // Opción B: lh3.googleusercontent.com/d/... (Suele ser más rápido para imágenes)
        return `https://lh3.googleusercontent.com/d/${matchId[1]}`;
    }

    // Intento 2: Extraer de id=.......
    const matchIdParam = url.match(/[?&]id=([a-zA-Z0-9_-]+)/);
    if (matchIdParam && matchIdParam[1]) {
        return `https://lh3.googleusercontent.com/d/${matchIdParam[1]}`;
    }

    return url;
};

// Un producto/promo puede tener varias imagenes guardadas en UrlImagen separadas por coma.
// Devuelve la lista de links directos (listos para <img src>), filtrando vacios.
export const getImageList = (urls: string | null | undefined): string[] => {
    if (!urls) return [];
    return urls
        .split(',')
        .map(u => u.trim())
        .filter(Boolean)
        .map(u => getGoogleDriveDirectLink(u))
        .filter((u): u is string => !!u);
};

// Imagen principal (la primera de la lista), o undefined si no hay ninguna.
export const getMainImage = (urls: string | null | undefined): string | undefined => {
    return getImageList(urls)[0];
};

type ProductImageSource = {
    UrlImagen?: string | null;
    UrlImagen2?: string | null;
    UrlImagen3?: string | null;
    imagenes?: string[];
};

export const getProductImageUrls = (source: ProductImageSource | null | undefined, maxItems = 3): string[] => {
    if (!source) return [];

    const urls: string[] = [];
    const values = [
        ...(Array.isArray(source.imagenes) ? source.imagenes : []),
        source.UrlImagen,
        source.UrlImagen2,
        source.UrlImagen3
    ];

    values.forEach(value => {
        getImageList(value).forEach(url => {
            if (!urls.includes(url) && urls.length < maxItems) {
                urls.push(url);
            }
        });
    });

    return urls;
};
